import SliderManager from "../../js/components/sliderManager";
import CustomSlider from "../../custom-slider/src/customSlider";

export default class HotelRoomCard extends HTMLElement {

    constructor() {
        super();
        this.customSlider = new CustomSlider();

        this.data = JSON.parse(this.getAttribute('data'));
        this.stylesheet = this.getAttribute('stylesheet');
        this.translations = JSON.parse(this.getAttribute('translations'));
        this.buttonURL = this.getAttribute('buttonURL')
        this.class = this.getAttribute('data-class')
        this.buttonAction = this.getAttribute('data-button-action');
    }

    static get observedAttributes() {
        return ['stylesheet', 'data', 'translations'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name == 'data') {
            this.data = JSON.parse(newValue);
        }
        if (name == 'stylesheet') {
            this.stylesheet = newValue;
        }
        if (name == 'translations') {
            this.translations = JSON.parse(newValue);
        }
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const template = document.querySelector('#hotel-room-card-template');
        this.instance = template.content.cloneNode(true);
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        if (this.class) {
            this.instance.querySelector('.hotel-room-card').classList.add(this.class);
        }
        this._fillImages();
        this._fillButtonContainer();
        this._fillHotelRoomItems();
        this._fillServices();
        this._shadowRoot.appendChild(this.instance);
    }

    setBookingButtonClick(clickFunction) {
        clickFunction(this._shadowRoot.querySelector('[name="booking-button"]'));
    }

    initializeSlider() {
        let imageGallerySliderContainer = this._shadowRoot.querySelector('[name="hotel-room-gallery"]');

        if (this.data.images.length === 0 || !imageGallerySliderContainer) {
            return;
        }

        this.sliderManager.addSlider(
            imageGallerySliderContainer,
            {
                slidesPerView: 1,
                navigation: true,
                pagination: true
            }
        );
    }

    _fillImages() {
        if (this.data.images && this.data.images.length !== 0) {
            let imageGallerySliderContainer = this.instance.querySelector('[name="hotel-room-gallery"]');
            if (this.data.images.length > 1) {
                let customSliderElement = this.customSlider.buildSlider(this._createSliderElements(this.data.images));
                imageGallerySliderContainer.appendChild(customSliderElement);
            } else {
                let singleImg = document.createElement('img');
                singleImg.classList.add('single-img');
                singleImg.src = this.data.images[0];
                imageGallerySliderContainer.appendChild(singleImg);
            }
        } else {
            this.instance.querySelector('[name="hotel-room-card-left"]').remove();
            this.instance.querySelector('[name="hotel-room-card-right"]').classList.add('full-width');
        }
    }

    _fillButtonContainer() {
        let buttonContainer = this.instance.querySelector('[name="button-container"]');
        if (this.translations.buttonText && this.buttonURL) {
            let button;
            let buttonText;
            if (this.buttonAction){
                button = document.createElement('button');
            } else {
                button = document.createElement('a');
            }
            buttonText = document.createTextNode(this.translations.buttonText)
            button.classList.add('btn', 'btn-complementary', 'hotel-card-button');
            button.appendChild(buttonText);
            if (this.buttonURL) {
                button.href = this.buttonURL;
            }
            if (this.buttonAction){
                if (this.buttonAction == 'calendar'){
                    button.addEventListener('click', () =>{
                        document.querySelector('#product-searcher [data-toggle="booking-dates"]').click();
                    })
                }
            }
            buttonContainer.appendChild(button);
        } else {
            buttonContainer.style.visibility = 'hidden';
        }
    }

    _createSliderElements(imageUrls) {
        let imageElement;
        let imageElements = [];

        for (const key in imageUrls) {
            imageElement = document.createElement('img');
            imageElement.src = imageUrls[key];
            imageElements.push(imageElement);
        }

        return imageElements;
    }

    _fillHotelRoomItems() {
        this._fillElement('name', this.data.name);
        const hotelRoomItemTemplate = document.querySelector('#hotel-room-item-template');

        let hotelRoomCardItemsContainer = this.instance.querySelector('[name="hotel-room-card-items"]');

        if (this.data.size) {
            let size = hotelRoomItemTemplate.content.cloneNode(true);
            size.querySelector('i').classList.add('ci-area');
            size.querySelector('[name="item-value"]').innerHTML = this.data.size + ' m2';
            hotelRoomCardItemsContainer.appendChild(size);
        }

        if (this.data.capacity) {
            let capacity = hotelRoomItemTemplate.content.cloneNode(true);
            capacity.querySelector('i').classList.add('ci-multiple-users');
            capacity.querySelector('[name="item-value"]').innerHTML = this.data.capacity;
            hotelRoomCardItemsContainer.appendChild(capacity);
        }

        if (this.data.bed_distribution) {
            let bedDistribution = hotelRoomItemTemplate.content.cloneNode(true);
            bedDistribution.querySelector('i').classList.add('ci-single-bed');
            bedDistribution.querySelector('[name="item-value"]').innerHTML = this.data.bed_distribution;
            hotelRoomCardItemsContainer.appendChild(bedDistribution);
        }

        if (this.data.extra_info) {
            let extraInfo = hotelRoomItemTemplate.content.cloneNode(true);
            extraInfo.querySelector('i').classList.add('ci-hand-point-right');
            extraInfo.querySelector('[name="item-value"]').innerHTML = this.data.extra_info;
            hotelRoomCardItemsContainer.appendChild(extraInfo);
        }

        this._fillElement('description', this.data.description);
    }

    _fillServices() {
        let servicesText = '';

        if (this.data.services && this.data.services.length > 0) {
            let lastElement = this.data.services[this.data.services.length - 1];

            if (this.translations && this.translations.services) {
                this._fillElement('services-title', this.translations.services);
            }
            for (let service of this.data.services) {
                servicesText = servicesText + service.text;
                if (lastElement !== service) {
                    servicesText = servicesText + ' | ';
                }
            }
        }
        this._fillElement('services', servicesText);
    }

    _fillElement(elementName, elementText) {
        let element = this.instance.querySelector('[name="' + elementName + '"]');
        element.innerHTML = elementText;
    }

    initializeSwiper(Swiper) {
        this.sliderManager = new SliderManager(Swiper);
        setTimeout(() => {
            this.initializeSlider();
        }, 200);
    }
}
